import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { y: 90 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/Home')
    },
    {
      path: '/cases',
      name: 'Cases',
      component: () => import('@/pages/Cases')
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: () => import('@/pages/AboutUs')
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('@/pages/NotFound')
    }
  ]
})
